(function () {
  // 和你现有 Klaviyo 逻辑里一致的「从 href 取 id」实现，若你已有全局函数可复用
  function getIdFromUrl(href) {
    if (!href || typeof href !== 'string') return null;
    try {
      var url = new URL(href, window.location.origin);
      var match =
        url.pathname.match(/\/([a-zA-Z0-9]+)$/) ||
        url.searchParams.get('id') ||
        url.hash.slice(1);
      return (match && (typeof match === 'string' ? match : match[1])) || null;
    } catch (e) {
      return null;
    }
  }

  function isKlaviyoPopupLink(anchor) {
    var title = (anchor.getAttribute('title') || '').toLowerCase();
    var href = anchor.getAttribute('href');
    var id = getIdFromUrl(href);
    return title === 'klaviyo' && !!id;
  }

  function isExternalLink(anchor) {
    var href = (anchor.getAttribute('href') || '').trim();
    if (
      !href ||
      href === '#' ||
      href.startsWith('javascript:') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:')
    ) {
      return false;
    }
    try {
      var url = new URL(href, window.location.origin);
      return url.hostname !== window.location.hostname;
    } catch (e) {
      return false;
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest('a');
      if (!a || !a.href) return;

      // 若是 Klaviyo 弹窗链接或声明「不自动新开 Tab」的链接，不处理
      if (isKlaviyoPopupLink(a) || a.hasAttribute('data-no-external-new-tab')) return;

      if (isExternalLink(a)) {
        e.preventDefault();
        window.open(a.href, '_blank', 'noopener,noreferrer');
      }
    },
    true,
  );
})();
